import {Mod_TerrainDefinition} from "./ObjModifiers/Mod_TerrainDefinition.js";
import {Mod_TerrainRegion} from "./ObjModifiers/Mod_TerrainRegion.js";
import {Mod_TerrainSpotHeight} from "./ObjModifiers/Mod_TerrainSpotHeight.js";
import {Mod_TerrainMaterials} from "./ObjModifiers/Mod_TerrainMaterials.js";
import {Mod_TerrainSceneries} from "./ObjModifiers/Mod_TerrainSceneries.js";
import {Mod_Viewpoint} from "./ObjModifiers/Mod_Viewpoint.js";
import {Mod_Building} from "./ObjModifiers/Mod_Building.js";
import {Mod_Level} from "./ObjModifiers/Mod_Level.js";
import {Mod_Room} from "./ObjModifiers/Mod_Room.js";
import {Mod_Window} from "./ObjModifiers/Mod_Window.js";
import {Mod_Door} from "./ObjModifiers/Mod_Door.js";
import {Mod_Opening} from "./ObjModifiers/Mod_Opening.js";

export class ObjModifier {
	constructor(data: Partial<ObjModifier>) { Object.assign(this, data); }

	enabled = true;

	terrainDefinition?: n|Mod_TerrainDefinition;
	terrainRegion?: n|Mod_TerrainRegion;
	/** V3: spot-height pin at this MapObject's anchor point. See `Mod_TerrainSpotHeight`. */
	terrainSpotHeight?: n|Mod_TerrainSpotHeight;
	/** Set9 Phase 7: procedural-material recipes, placed instances, + region assignments. See `Mod_TerrainMaterials`. */
	terrainMaterials?: n|Mod_TerrainMaterials;
	/** Set13: user-authored scenery kinds + the global scenery budget. See `Mod_TerrainSceneries`. */
	terrainSceneries?: n|Mod_TerrainSceneries;
	/** Set15 P0: a locked 3D-camera viewpoint (position from the host MapObject's anchor,
	 *  height + orientation from this modifier). See `Mod_Viewpoint`. */
	viewpoint?: n|Mod_Viewpoint;
	/** Buildings Set1 (§2.6): the building-level modifier — owns the grouped inheritable defaults
	 *  and (unless a prototype) generates the building's floors/walls/roofs. See `Mod_Building`. */
	building?: n|Mod_Building;
	/** Buildings Set1 (§2.3): a floor of a building; owns a subtree of Rooms. See `Mod_Level`. */
	level?: n|Mod_Level;
	/** Buildings Set1 (§2.4): a single space within a Level. See `Mod_Room`. */
	room?: n|Mod_Room;
	/** Buildings Set1 (§2.5): an opening in a wall of the closest ancestor Room. See `Mod_Window`. */
	window?: n|Mod_Window;
	/** Buildings Set1 (§2.5): an opening (at floor level) in a wall of the closest ancestor Room.
	 *  See `Mod_Door`. */
	door?: n|Mod_Door;
	/** Buildings Set1 follow-up: a full-height, full-width-of-`width` opening in a wall of the
	 *  closest ancestor Room. Unlike a Door/Window it "punches out" the ENTIRE wall (floor slab
	 *  top → wall top), so it emits no sill/frame/model — used to stop wall-mesh generation
	 *  between two Rooms that are part of the same open space. See `Mod_Opening`. */
	opening?: n|Mod_Opening;
}